import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=013c4a26&scoped=true&"
import script from "./WorksList.vue?vue&type=script&lang=js&"
export * from "./WorksList.vue?vue&type=script&lang=js&"
import style0 from "./WorksList.vue?vue&type=style&index=0&id=013c4a26&lang=scss&scoped=true&"
import style1 from "./WorksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013c4a26",
  null
  
)

export default component.exports